import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

export const FAQ = () => {
  const faqs = [
    {
      question: '¿Qué tipo de libros publican?',
      answer: 'Libros de desarrollo personal en distintas categorías: espiritualidad, negocios, salud y todo lo que aporte a la humanidad. Buscamos contenido honesto y aplicable a la vida real.'
    },
    {
      question: '¿Tengo que pagar por adelantado?',
      answer: 'Evaluamos caso por caso. Priorizamos proyectos que sumen valor real; hablamos condiciones claras desde el principio.'
    },
    {
      question: '¿Cuánto tiempo lleva el proceso?',
      answer: 'Depende del manuscrito, pero suele ser 2-6 meses desde entrega hasta publicación.'
    },
    {
      question: '¿Publican solo digital o también físico?',
      answer: 'Ambas opciones: digital en Amazon y otras plataformas, físico bajo demanda si el proyecto lo justifica.'
    },
    {
      question: '¿Qué derechos conservo?',
      answer: 'Todos los derechos de autor siguen siendo tuyos. Solo cedés distribución temporal según acuerdo.'
    },
    {
      question: '¿Cómo contacto?',
      answer: 'Directo por WhatsApp: +54 260 480-1102. Te respondemos rápido y sin vueltas.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <HelpCircle className="text-amber-600" size={48} />
            </div>
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              Preguntas frecuentes
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Todo lo que necesitás saber, sin rodeos
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <AccordionTrigger className="px-6 py-4 text-left hover:no-underline">
                  <span className="text-lg md:text-xl font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4">
                  <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Contact Prompt */}
          <div className="mt-12 text-center">
            <p className="text-lg text-gray-600 mb-4">
              ¿Tenés otra pregunta?
            </p>
            <a 
              href="https://wa.me/542604801102?text=Hola%2C%20tengo%20una%20consulta%20sobre%20Ra%C3%ADz%20Lecturas"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-amber-700 hover:text-amber-800 font-semibold transition-colors duration-300"
            >
              <span>Escribinos por WhatsApp</span>
              <span className="text-2xl">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};